import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { enFeaturesLabels } from "./en";
import { itFeaturesLabels } from "./it";

export const featuresLabels: LocaleModule = {
  name: "features",
  messages: { en: enFeaturesLabels, it: itFeaturesLabels },
};
